import { types } from "../../types/types";
import { fetchConToken } from "../../helpers/fetch";
import { startAlerta } from "../ui/alertas";
import { armarParametros } from "../../helpers/parametros";
import { startSpinner,finishSpinner } from "../ui/spinner";

export const licenciasProfesionalesTraerStart = () => ({ type: types.licenciasProfesionalesTraerStart });
export const licenciasProfesionalesLimpiar = () => ({ type: types.licenciasProfesionalesLimpiar });
export const licenciasProfesionalesTraerError = (error) => ({ type: types.licenciasProfesionalesTraerError, payload: error});
export const licenciasProfesionalesSeleccionar = (error) => ({ type: types.licenciasProfesionalesSeleccionar, payload: error});
export const licenciasProfesionalesUpdateDisabled = (payload) => ({ type: types.licenciasProfesionalesUpdateDisabled, payload: payload});
export const licenciasProfesionalesModificarInHabilitado = (payload) => ({ type: types.licenciasProfesionalesModificarInHabilitado, payload: payload});
export const licenciasProfesionalesTraerSuccess = (payload) => {
    return {
        type: types.licenciasProfesionalesTraerSuccess,
        payload: payload
    }
}
export const licenciasProfesionalesDemandaTraerSuccess = (payload) => {
  return {
      type: types.licenciasProfesionalesDemandaTraerSuccess,
      payload: payload
  }
}

export const fetchlicenciasProfesionales = (idCentroMedico, idProfesional, idEspecialidad) => {
    return async (dispatch) => {
      try{
        dispatch(startSpinner());
        dispatch(licenciasProfesionalesTraerStart());
        const parametros = armarParametros(idEspecialidad, idCentroMedico, idProfesional);
        const response = await fetchConToken(`EfectorLicencias/traer?${parametros}`);
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          const lista = await response.json();
          if (response.status !== 200) throw lista.errores;
          dispatch(licenciasProfesionalesTraerSuccess(lista));
        }
        dispatch(finishSpinner());
      } catch (err){
        dispatch(finishSpinner());
        dispatch(startAlerta(err, "warning", `¡Error!`));
      }
    };
};

export const agregarLicenciaProfesional = (parametros, idMotivoBajaTurno) => {
  return async (dispatch) => {
    try{
      dispatch(startSpinner());
      dispatch(licenciasProfesionalesTraerStart());
      const response = await fetchConToken(`EfectorLicencias`, {parametros, idMotivoBajaTurno}, 'POST');
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        if (response.status !== 200) throw lista.errores;
        dispatch(licenciasProfesionalesTraerSuccess(lista));
      }
      dispatch(finishSpinner());
    } catch (err){
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const habilitarInhabilitarLicenciaProfesional = (idEfectorLicencias, habilitado) => {
  return async (dispatch) => {
    try{
      dispatch(startSpinner());
      const response = await fetchConToken(`EfectorLicencias/editarHabilitado`, {idEfectorLicencias, habilitado}, 'PUT');
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
          const item = await response.json();
          if (response.status !== 200) throw item.errores;

          dispatch( licenciasProfesionalesModificarInHabilitado({idEfectorLicencias, habilitado: habilitado ? null : new Date()}) );
      }
      dispatch(finishSpinner());
    } catch (err){
        dispatch(finishSpinner());
        dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};